export const PUBLISHED = 'published';
export const UNPUBLISHED = 'unpublished';